export const postbox = {
    title: "Send a Message to {{name}}'s Postbox location.",
    whatIsPostbox: "What is the OVERHEAR Postbox?",
    description: "Record an audio message to send to this postbox. Note: The person receiving your message must have the OVERHEAR app downloaded.",
    descriptionDetail: "Your message will be delivered directly to their postbox. The recipient must have the OVERHEAR app to receive your message. Click the button below to start recording your message.",
    landing: {
      title: "Postbox Portal",
      description: "Send audio messages to OVERHEAR users through their postbox. Recipients must have the OVERHEAR app downloaded to receive messages.",
      howItWorks: "How It Works",
      explanation: "Postbox allows you to send audio messages to OVERHEAR users without needing the app yourself. When someone shares their postbox link with you, you can use it to leave them a message. Note: The person receiving your message must have the OVERHEAR app downloaded.",
      linkInstructions: "You should receive a share link that will take you directly to the message recording page. Simply click the link you received to get started!",
      downloadApp: "Download the OVERHEAR App",
      appDescription: "For the best experience, download the OVERHEAR app to receive and manage your postbox messages, plus access all other features."
    },
    earlyAccess: {
      title: "Request Early Access to Postbox",
      description: "Enter the email address you used to sign up for OVERHEAR.",
      emailLabel: "Email Address",
      emailPlaceholder: "your.email@example.com",
      submit: "Request Early Access",
      success: "Thank you! We'll notify you when postbox is available.",
      notRegistered: "This email isn't registered. Please download the OVERHEAR app and sign up first.",
      error: "An error occurred. Please try again."
    },
    accessCode: {
      title: "Enter Access Code",
      description: "Please enter the 6-digit access code to continue",
      instructions: "This postbox is protected with an access code. Enter the 6-digit code that was provided to you to continue sending your message.",
      label: "Access Code",
      helperText: "Enter 6 digits",
      submit: "Continue",
      invalidLength: "Access code must be 6 digits",
      invalid: "Invalid access code. Please try again.",
      submitError: "Failed to validate access code. Please try again."
    },
    recording: {
      title: "Record Your Message",
      instructionsTitle: "Create Your Audio Message",
      instructions: "Click the red button below to start recording your message using your device's microphone. When you're done, click the button again to stop. You can preview your recording before sending.",
      start: "Start Recording",
      stop: "Stop Recording",
      recording: "Recording...",
      playing: "Playing...",
      readyToPlay: "Ready to play",
      delete: "Delete Recording",
      microphoneError: "Unable to access microphone. Please check your permissions."
    },
    upload: {
      title: "Upload Audio File",
      selectFile: "Choose Audio File",
      dragDrop: "Or drag and drop an audio file here",
      supportedFormats: "Supported formats: M4A, MP3, WAV, WebM, OGG",
      maxSize: "Max 100MB",
      invalidFormat: "Invalid audio format. Please use M4A, MP3, WAV, WebM, or OGG.",
      fileTooLarge: "File is too large. Maximum size is 100MB."
    },
    status: {
      successTitle: "Message Sent!",
      successMessage: "Your message has been sent successfully.",
      sendAnother: "Send Another Message",
      errorTitle: "Error",
      errorMessage: "Failed to send message. Please try again.",
      tryAgain: "Try Again"
    },
    ready: {
      title: "Ready to Send",
      description: "Review your audio message below. If you're happy with it, click 'Send Message' to deliver it to the postbox. You can also record a new message if you'd like to change it.",
      recordAgain: "Record Again",
      send: "Send Message"
    },
    error: {
      invalidToken: "Invalid or missing token",
      invalidLink: "This link is no longer valid or has expired.",
      validationFailed: "Failed to validate link. Please try again.",
      missingData: "Missing required information. Please try again.",
      sendFailed: "Failed to send message. Please try again.",
      generic: "An error occurred. Please try again."
    },
    portal: {
      appPrompt: "Want to send and receive more messages to a special location?",
      appPromptDescription: "Download the OVERHEAR app to create your own postbox and send messages to specific locations."
    }
}